module.exports = __webpack_public_path__ + "img/b.bdb1ea32.jpg";